// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_paginationWrapper__2iy1V {
  display: flex;
  justify-content: end;
  margin-block: 1rem;
}

.styles_addRole__DclNM {
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  text-decoration: none;
  cursor: pointer;
}


.styles_buttonAddRole__hp4Ca {
  align-items: center;
  background-color: #5d87ff;
  border: 0;
  border-radius: 8px;
  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;
  box-sizing: border-box;
  color: #ffffff;
  font-weight: 500;
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 1em;
  max-width: 100%;
  padding: 13px 15px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}

.styles_buttonAddRoleOutline__ql3xz {
  background: transparent;
  border-color:rgb(25, 118, 210,0.7);
  color: rgb(25, 118, 210);
  align-items: center;
  border-radius: 8px;
  box-sizing: border-box;
  font-weight: 500;
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 1em;
  max-width: 100%;
  padding: 12px 15px;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  white-space: nowrap;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/onboardDevice/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".paginationWrapper {\n  display: flex;\n  justify-content: end;\n  margin-block: 1rem;\n}\n\n.addRole {\n  display: flex;\n  justify-content: end;\n  margin-bottom: 20px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n\n.buttonAddRole {\n  align-items: center;\n  background-color: #5d87ff;\n  border: 0;\n  border-radius: 8px;\n  box-shadow: rgba(151, 65, 252, 0.2) 0 15px 30px -5px;\n  box-sizing: border-box;\n  color: #ffffff;\n  font-weight: 500;\n  display: flex;\n  font-size: 14px;\n  justify-content: center;\n  line-height: 1em;\n  max-width: 100%;\n  padding: 13px 15px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.buttonAddRoleOutline {\n  background: transparent;\n  border-color:rgb(25, 118, 210,0.7);\n  color: rgb(25, 118, 210);\n  align-items: center;\n  border-radius: 8px;\n  box-sizing: border-box;\n  font-weight: 500;\n  display: flex;\n  font-size: 14px;\n  justify-content: center;\n  line-height: 1em;\n  max-width: 100%;\n  padding: 12px 15px;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  white-space: nowrap;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationWrapper": `styles_paginationWrapper__2iy1V`,
	"addRole": `styles_addRole__DclNM`,
	"buttonAddRole": `styles_buttonAddRole__hp4Ca`,
	"buttonAddRoleOutline": `styles_buttonAddRoleOutline__ql3xz`
};
export default ___CSS_LOADER_EXPORT___;
